import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Container, IconButton, ThemeProvider, createTheme } from '@mui/material';
import { Close, KeyboardArrowDown } from '@mui/icons-material';
import { useQuery } from '../../hooks/useQuery';
import { RootState, useAppDispatch } from '../../store';
import Search from '../SearchMain/Search';
import ListTypeMobile from '../../components/ListTypeMobile/ListTypeMobile';
import SearchList from './SearchList';
import { Action, Category, getActions, getCategories, getLocationTypes } from '../../store/buyerSlice';
import SelectLocations from '../../components/SelectLocations';

type ListSearchType = 'actions' | 'category' | 'locations' | 'price';

type ListSearchItem = {
  id: number;
  name: string;
  type: ListSearchType;
};

type ListSearch = {
  th: ListSearchItem[];
  en: ListSearchItem[];
  cn: ListSearchItem[];
};

const listSearch: ListSearch = {
  th: [
    { id: 1, name: 'ต้องการ', type: 'actions' },
    { id: 2, name: 'หมวดหมู่', type: 'category' },
    { id: 3, name: 'ที่ตั้ง', type: 'locations' },
    { id: 4, name: 'ราคา', type: 'price' },
  ],
  en: [
    { id: 1, name: 'Action', type: 'actions' },
    { id: 2, name: 'Category', type: 'category' },
    { id: 3, name: 'Location', type: 'locations' },
    { id: 4, name: 'Price', type: 'price' },
  ],
  cn: [
    { id: 1, name: '需求', type: 'actions' },
    { id: 2, name: '类型', type: 'category' },
    { id: 3, name: '地点', type: 'locations' },
    { id: 4, name: '价格', type: 'price' },
  ],
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#f3f3f3',
      contrastText: '#090909',
    },
    text: {
      primary: '#172b4d',
      secondary: '#6b778c',
    },
  },
});

interface SearchBuyerState {
  action: Action | null;
  category: Category | null;
}

const initState: SearchBuyerState = {
  action: null,
  category: null,
};

const SearchBuyer = () => {
  const dispatch = useAppDispatch();
  const query = useQuery();
  const [target, setTarget] = useState<string>('9assetApp');
  const [language, setLangunage] = useState<'th' | 'en' | 'cn'>('th');
  const [activeMenu, setActiveMenu] = useState<ListSearchType | null>(null);
  const [state, setState] = useState<SearchBuyerState>(initState);

  useEffect(() => {
    if (query.has('target')) {
      setTarget(query.get('target') || '9assetApp');
    }
    dispatch(getActions());
    dispatch(getCategories());
    dispatch(getLocationTypes());
  }, []);

  const handleOnClose = () => {
    if (window.parent) {
      const msg = {
        target: target || '9assetApp',
        type: 'mobileSearch-goto-close',
        value: undefined,
      };
      window.parent.postMessage(msg, '*');
    }
  };

  const handleSelected = (type: ListSearchType, item: Action | Category | null) => {
    if (type === 'actions') {
      setState({ ...state, action: item as Action });
    } else if (type === 'category') {
      setState({ ...state, category: item as Category });
    }
    setActiveMenu(null);
  };

  const getSelected = (item: ListSearchItem) => {
    if (language === undefined) return;

    if (item.type === 'actions') {
      return <div className="text-slate-600">{state.action ? state.action?.nameTH : item.name}</div>;
    } else if (item.type === 'category') {
      return <div className="text-slate-600">{state.category ? state.category?.nameTH : item.name}</div>;
    }

    return <div className="text-slate-600">{item.name}</div>;
  };

  const handleApplySearch = () => {
    if (window.parent) {
      console.log(window);
      const massage = {
        target: target || '9assetApp',
        type: 'mobileSearch-goto',
        payload: state,
      };
      window.parent.postMessage(massage, '*');
    }
  };

  const renderDefault = () => (
    <Box sx={{ padding: '0px' }}>
      <Box component={'div'} sx={{ display: 'flex', justifyContent: 'end' }}>
        <IconButton onClick={handleOnClose}>
          <Close />
        </IconButton>
      </Box>
      <Container>
        <Box>
          <Search />
        </Box>
        <Box sx={{ marginTop: '16px' }}>
          {listSearch['th'].map((item: ListSearchItem, index: number) => {
            return (
              <Box key={index}>
                <Box
                  component="div"
                  className="border px-4 rounded flex justify-between items-center my-2 bg-[#f8e8de] border-[#f8e8de]"
                  onClick={() => {
                    setActiveMenu(item.type);
                  }}>
                  {getSelected(item)}
                  <IconButton>
                    <KeyboardArrowDown />
                  </IconButton>
                </Box>
              </Box>
            );
          })}
        </Box>
        <button
          className="border rounded flex justify-center items-center w-full py-2 mt-6 bg-[#f4762a] text-white"
          onClick={handleApplySearch}>
          ค้นหา
        </button>
      </Container>
    </Box>
  );

  const renderActivedMenu = () => {
    if (activeMenu === 'actions' || activeMenu === 'category') {
      return (
        <SearchList
          type={activeMenu}
          onBackRequest={() => setActiveMenu(null)}
          onSelected={(selected) => handleSelected(activeMenu, selected)}
        />
      );
    } else if (activeMenu === 'locations') {
      return <SelectLocations onBackRequest={() => setActiveMenu(null)} />;
    } else {
      return <></>;
    }
  };

  return <ThemeProvider theme={theme}>{activeMenu === null ? renderDefault() : renderActivedMenu()}</ThemeProvider>;
};

export default SearchBuyer;
